import { constTrue } from 'fp-ts/function';
export * from 'fp-ts/Eq';
export const trivial = {
    equals: constTrue,
};
export const isEqualTo = (e) => (a) => (b) => e.equals(a, b);
/**
 * Return an Eq instance for nullable values.
 * `null` and `undefined` values are considered equal.
 */
export const nullable = (e) => ({
    equals: (a, b) => (a == null && b == null) || (a != null && b != null && e.equals(a, b)),
});
//# sourceMappingURL=eq.js.map